import Vue from 'vue'

import { formatAmount } from '@/utils'

Vue.filter('formatPercentage', (value: string) => {
  return value ? `${value} %` : ''
})

Vue.filter('formatAmount', formatAmount)
